export type EquityNotifRowVariant = 'warning' | 'info' | 'success' | 'secondary';

export function getEquityMarketNotificationVariant(
  title: string
): EquityNotifRowVariant {
  const t = (title || '').toLowerCase();
  if (
    t.includes('pago') ||
    t.includes('documentación pendiente') ||
    t.includes('acción requerida')
  ) {
    return 'warning';
  }
  if (
    t.includes('documentación') ||
    t.includes('nueva documentación') ||
    t.includes('comentario')
  ) {
    return 'info';
  }
  if (
    t.includes('completad') ||
    t.includes('aceptad') ||
    t.includes('activa') ||
    t.includes('registrad')
  ) {
    return 'success';
  }
  return 'secondary';
}

export function getEquityMarketNotificationIcon(variant: EquityNotifRowVariant) {
  switch (variant) {
    case 'warning':
      return 'ni-cc-alt2';
    case 'info':
      return 'ni-file-docs';
    case 'success':
      return 'ni-check-circle';
    default:
      return 'ni-offer';
  }
}
